(function () {
    'use strict';

    angular
        .module('app')
        .directive('awcDatePicker', awcDatePicker);

    awcDatePicker.$inject = ['$filter', 'loginService', 'enumFactory', 'searchService'];

     function awcDatePicker($filter, loginService, enumFactory, searchService) {
        //
        // Usage:
        //
        // <awc-date-picker 
        //      mode="edit"                             // "edit" for only allowing them to pick 'On' date, (default) "search" to allow picking 'On, After, and/or Before'
        //      disabled="true"                         // true/false to disable the button.
        //      textbox-id="id"                         // id of the textbox that goes with the button
        //      date-format="dateOnlyFormatter"         // Date format from edit-options.
        //      date-picked="onDatePicked(id, sDate)"   // function to call when a date is picked. params are textbox-id, and date converted to a string
        //                                              //   "2015-07-04", or ">2015-01-01", or "<2015-12-31", or ">2015-01-01 & <2015-12-31"
        // >                            
        // </awc-date-picker>
        //
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                sMode: "@mode",
                ngDisabled: '=?',
                textboxId: '=',
                dateFormat: '=?', // unused.
                datePicked: '=', //changed from & to reference function instead of = 
                currentDate: '=',
                currentDateSetting: '=',
                tabIndex: '=',
                backgroundColor: "=?"
            },
            templateUrl: 'app/awcDatePicker/awcDatePicker.html'
        };
        return directive;

         // Called once on load.
        function link(scope, element, attrs) {

            scope.msgbox = {};
            scope.msgbox.visible = false;

            console.log('datePickerId=' + scope.textboxId + ', backgroundcolor=' + scope.backgroundColor);

            scope.msgboxShow = function (message, title) {
                scope.msgbox.message = message;
                scope.msgbox.title = title;
                scope.msgbox.visible = true;

                //$timeout(function () {
                //    scope.msgbox.visible = false;
                //}, 3000)
            }

            scope.dateParse = function (localDate) {
                var tmp = searchService.dateParse(localDate);
                return tmp;
            }

            scope.dateToString = function (d) {
                var str = searchService.dateToString(d);
                return str;
            }
            
            //date format used for the picker and for the value result populating the input box
            // Format is the browser default, or provided by caller - scope.myDateFormat = 'MM/dd/yyyy';
            
            scope.awcDatePickerShown = false;
            
            // 0 for search, 1 for edit
            scope.mode = 0;
            if (scope.sMode == 'edit')
                scope.mode = 1;

            //added pickerOptions enum for option switch in ng-change call of html and for readability
            scope.pickerOptions = {
                OnDate: 0,
                AfterDate: 1,
                BeforeDate: 2,
                HasDate: 3,
                HasNoDate: 4
            }

            //added date operator options for date search object
            //these values correspond to Adept's date search expectations (i.e. <date>,<date>,<operation>)
            //both has date and has no date handle the wildcard searching
            scope.dateOperations = {
                OnDate: 0,
                AfterDate: 1,
                BeforeDate: 2,
                DateRange: 3,
                HasDate: 4,
                HasNoDate: 5
            }

            //create the dates scope object for the picker ng-models
            scope.dates = {
                dtOn: scope.dateParse(scope.dateToString(new Date())),
                dtBefore: scope.dateParse(scope.dateToString(new Date())),
                dtAfter: scope.dateParse(scope.dateToString(new Date()))
            }


            //add object to be consumed through search criteria
            scope.dateSearch = {
                onDateSearchValue: scope.dates.dtOn,
                afterDateSearchValue: scope.dates.dtAfter,
                beforeDateSearchValue: scope.dates.dtBefore,
                dateOperation: scope.dateOperations.OnDate
            }



            // On show.
            scope.onShowAWCDatePicker = function () {

                scope.myDateFormat = scope.dateFormat; // used in HTML

                scope.inCheckChange = false;

                scope.onLabel = loginService.resourceStrings["ON"]; // "On"
                scope.beforeLabel = loginService.resourceStrings["BEFORE"]; // "Before"
                scope.afterLabel = loginService.resourceStrings["AFTER"]; // "After"
                scope.closeLabel = loginService.resourceStrings["CLOSE"]; // "Close"
                scope.okLabel = loginService.resourceStrings["OK"]; // "OK"
                scope.cancelLabel = loginService.resourceStrings["CANCEL"]; // "Cancel"
                scope.clearLabel = loginService.resourceStrings["CLEAR"]; // "Clear"
                scope.todayLabel = loginService.resourceStrings["TODAY"]; // "Today"

                //added labels for has date and has no date
                //defect: 20742
                scope.hasDateLabel = loginService.resourceStrings["HAS_DATE"]; // "Has Date"
                scope.hasNoDateLabel = loginService.resourceStrings["HAS_NO_DATE"]; // "Has No Date"
                //end 20742

                // checkbox enable
                scope.allows = {
                    onIsAllowed: true,
                    beforeIsAllowed: true,
                    afterIsAllowed: true,

                    //defect: 20742
                    hasDateIsAllowed: true,
                    hasNoDateIsAllowed: true
                    //end 20742
                };

                // checkbox state
                scope.checks = {
                    onIsChecked: false,
                    beforeIsChecked: false,
                    afterIsChecked: false,

                    //defect: 20742
                    hasDateIsChecked: false,
                    hasNoDateIsChecked: false
                    //end 20742
                };

                // status of popup for uib date picker
                scope.status = {
                    openedOn: false,
                    openedBefore: false,
                    openedAfter: false
                };

                if (scope.mode == 1) {
                    if (scope.currentDate != null) {
                        if (scope.currentDate == "") {
                            scope.dates.dtOn = scope.dateParse(scope.dateToString(new Date()));
                        }
                        else {
                            scope.dates.dtOn = scope.dateParse(scope.currentDate);
                        }
                        
                    }
                }
                else {
                    if (scope.currentDateSetting != null) {
                        if (scope.currentDateSetting.searchOp == enumFactory.searchOperator.OnDate) {
                            scope.checks.onIsChecked = true;
                            scope.dates.dtOn = scope.dateParse(scope.currentDateSetting.valueStr);
                        }
                        else if (scope.currentDateSetting.searchOp == enumFactory.searchOperator.AfterDate) {
                            scope.checks.afterIsChecked = true;
                            scope.dates.dtAfter = scope.dateParse(scope.currentDateSetting.valueStr);
                        }
                        else if (scope.currentDateSetting.searchOp == enumFactory.searchOperator.BeforeDate) {
                            scope.checks.beforeIsChecked = true;
                            scope.dates.dtBefore = scope.dateParse(scope.currentDateSetting.valueStr);
                        }
                        else if (scope.currentDateSetting.searchOp == enumFactory.searchOperator.DateRange) {
                            scope.checks.afterIsChecked = true;
                            scope.checks.beforeIsChecked = true;
                            scope.dates.dtAfter = scope.dateParse(scope.currentDateSetting.startDate);
                            scope.dates.dtBefore = scope.dateParse(scope.currentDateSetting.endDate);
                        }
                        else if (scope.currentDateSetting.searchOp == enumFactory.searchOperator.NotEmpty) {
                            scope.checks.hasDateIsChecked = true;
                        }
                        else if (scope.currentDateSetting.searchOp == enumFactory.searchOperator.Empty) {
                            scope.checks.hasNoDateIsChecked = true;
                        }
                    }
                }

                scope.awcDatePickerShown = true;

                // Do Enables
                // Changed numeric condition to enumerator (GT)
                scope.checkChange(scope.pickerOptions.OnDate);
            }

            // a checkbox has changed state
            scope.checkChange = function (which) {
                // If this is looping, just return.
                if (scope.inCheckChange)
                    return;
                // If we are only loading, just return.
                if (scope.awcDatePickerShown == false)
                    return;
                // Flag to know that we are changing checkbox states internally.
                scope.inCheckChange = true;

                // If in edit mode, user can only work with On.
                if (scope.mode == 1) {
                    scope.allows.onIsAllowed = false;
                    scope.checks.onIsChecked = true;

                    scope.allows.beforeIsAllowed = false;
                    scope.allows.afterIsAllowed = false;
                    scope.checks.beforeIsChecked = false;
                    scope.checks.afterIsChecked = false;

                    //defect: 20742
                    scope.allows.hasDateIsAllowed = false;
                    scope.allows.hasNoDateIsAllowed = false;
                    scope.checks.hasDateIsChecked = false;
                    scope.checks.hasNoDateIsChecked = false;
                    //end 20742
                }

                // Otherwise, we are in search mode.

                // If changing On
                // Changed numeric conditions to enumerators (GT)
                if (which == scope.pickerOptions.OnDate) {
                    //disabled code to disable options - could be added back in so i left the code here
                    /*
                    //if On is selected, before and after are disabled
                    scope.allows.beforeIsAllowed = !scope.checks.onIsChecked;
                    scope.allows.afterIsAllowed = !scope.checks.onIsChecked;
                    //defect: 20742
                    scope.allows.hasDateIsAllowed = !scope.checks.onIsChecked;
                    scope.allows.hasNoDateIsAllowed = !scope.checks.onIsChecked;
                    //end 20742
                    */
                    // If On, then uncheck Before and After, has date and has no date
                    if (scope.checks.onIsChecked) {
                        scope.checks.beforeIsChecked = false;
                        scope.checks.afterIsChecked = false;
                        //defect: 20742
                        scope.checks.hasDateIsChecked = false;
                        scope.checks.hasNoDateIsChecked = false;
                        //end 20742
                    }
                }
                    // Else, if changing before, ... 
                else if (which == scope.pickerOptions.BeforeDate) {
                    //disabled code to disable options - could be added back in so i left the code here
                    /*
                    // If before is checked, On is not allowed or checked, nor is has date and has no date.
                    scope.allows.onIsAllowed = !scope.checks.beforeIsChecked;
                    //defect: 20742
                    scope.allows.hasDateIsAllowed = !scope.checks.beforeIsChecked;
                    scope.allows.hasNoDateIsAllowed = !scope.checks.beforeIsChecked;
                    //end 20742
                    */
                    // If after, then uncheck on, has date and has no date
                    if (scope.checks.beforeIsChecked) {
                        scope.checks.onIsChecked = false;
                        //defect: 20742
                        scope.checks.hasDateIsChecked = false;
                        scope.checks.hasNoDateIsChecked = false;
                        //end 20742
                    }
                }
                    // Else, if changing after, ...
                else if (which == scope.pickerOptions.AfterDate) {
                    //disabled code to disable options - could be added back in so i left the code here
                    /*
                    // If after is checked, On is not allowed or checked.
                    scope.allows.onIsAllowed = !scope.checks.afterIsChecked;
                    //defect: 20742
                    scope.allows.hasDateIsAllowed = !scope.checks.afterIsChecked;
                    scope.allows.hasNoDateIsAllowed = !scope.checks.afterIsChecked;
                    //end 20742
                    */
                    // If before, then uncheck on, has date and has no date
                    if (scope.checks.afterIsChecked) {
                        scope.checks.onIsChecked = false;
                        //defect: 20742
                        scope.checks.hasDateIsChecked = false;
                        scope.checks.hasNoDateIsChecked = false;
                        //end 20742
                    }
                }
                    //defect: 20742
                    // Else, if changing has date, ...
                else if (which == scope.pickerOptions.HasDate) {
                    //disabled code to disable options - could be added back in so i left the code here
                    /*
                    // If has date is checked, nothing else is not allowed or checked.
                    scope.allows.onIsAllowed = !scope.checks.hasDateIsChecked;
                    scope.allows.beforeIsAllowed = !scope.checks.hasDateIsChecked;
                    scope.allows.afterIsAllowed = !scope.checks.hasDateIsChecked;
                    scope.allows.hasNoDateIsAllowed = !scope.checks.hasDateIsChecked;
                    */
                    // If before, then uncheck on, has date and has no date
                    if (scope.checks.hasDateIsChecked) {
                        scope.checks.onIsChecked = false;
                        scope.checks.beforeIsChecked = false;
                        scope.checks.afterIsChecked = false;
                        scope.checks.hasNoDateIsChecked = false;
                    }
                }
                    // Else, if changing has no date, ...
                else if (which == scope.pickerOptions.HasNoDate) {
                    //disabled code to disable options - could be added back in so i left the code here
                    /*
                    // If has no date is checked, nothing else is not allowed or checked.
                    scope.allows.onIsAllowed = !scope.checks.hasNoDateIsChecked;
                    scope.allows.beforeIsAllowed = !scope.checks.hasNoDateIsChecked;
                    scope.allows.afterIsAllowed = !scope.checks.hasNoDateIsChecked;
                    scope.allows.hasDateIsAllowed = !scope.checks.hasNoDateIsChecked;
                    */
                    // If before, then uncheck on, has date and has no date
                    if (scope.checks.hasNoDateIsChecked) {
                        scope.checks.onIsChecked = false;
                        scope.checks.beforeIsChecked = false;
                        scope.checks.afterIsChecked = false;
                        scope.checks.hasDateIsChecked = false;
                    }
                }
                //end 20742                

                // If neither Before or After, then On is allowed. Add has date and has no date (defect: 20742)
                if (!scope.checks.beforeIsChecked && !scope.checks.afterIsChecked && !scope.checks.hasDateIsChecked && !scope.checks.hasNoDateIsChecked) {
                    scope.allows.onIsAllowed = true;
                }

                // We are done changing the state of checkboxes internally.
                scope.inCheckChange = false;
            };

            // Opening the uib date picker.
            // Changed numeric conditions to enumerators (GT)
            scope.open = function ($event, which) {
                scope.which = which;
                if (scope.which == scope.pickerOptions.OnDate) {
                    scope.status.openedOn = true;
                }
                else if (scope.which == scope.pickerOptions.AfterDate) {
                    scope.status.openedAfter = true;
                }
                else if (scope.which == scope.pickerOptions.BeforeDate) {
                    scope.status.openedBefore = true;
                }
            };

            //changed function to use the scope.dateSearch object
            scope.onAWCDatePickerOK = function () {
                //set the date operation based on what's checked along with the date values
                //value the datesearch object with the values from the date boxes
                if (scope.checks.onIsChecked) {
                    if (scope.dates.dtOn == undefined) {
                        //scope.msgboxShow("Please select a valid date.", "Invalid date."); return;
                        scope.onClear();
                        return;
                    }

                    scope.dateSearch.dateOperation = scope.dateOperations.OnDate;
                    scope.dateSearch.onDateSearchValue = scope.dateToString(scope.dates.dtOn);
                }
                else if (scope.checks.afterIsChecked && scope.checks.beforeIsChecked) {
                    if (scope.dates.dtAfter == undefined) { scope.msgboxShow("Please select a valid date.", "Invalid date."); return; }
                    if (scope.dates.dtBefore == undefined) { scope.msgboxShow("Please select a valid date.", "Invalid date."); return; }

                    // Too be valid, a date is "After the 1st and Before the 7th", so After must be less (or equal) than Before.
                    // Since After and Before are inclusive, "After the 5th" means >=, and "Before the 5th" means <=.
                    // So, if something was both >= and <=, then it would only equal, but the search is still valid.
                    if (scope.dates.dtAfter > scope.dates.dtBefore) {
                        var msg = loginService.resourceStrings["AFTER_LESS_THAN_BEFORE"]; // "'After' must be less than 'Before'."
                        var title = loginService.resourceStrings["INVALID_DATE_RANGE"]; // "Invalid Date Range"
                        scope.msgboxShow(msg, title);
                        return;
                    }

                    scope.dateSearch.dateOperation = scope.dateOperations.DateRange;
                    scope.dateSearch.afterDateSearchValue = scope.dateToString(scope.dates.dtAfter);
                    scope.dateSearch.beforeDateSearchValue = scope.dateToString(scope.dates.dtBefore);
                }
                else if (scope.checks.afterIsChecked) {
                    if (scope.dates.dtAfter == undefined) { scope.msgboxShow("Please select a valid date.", "Invalid date."); return; }
                    scope.dateSearch.dateOperation = scope.dateOperations.AfterDate;
                    scope.dateSearch.afterDateSearchValue = scope.dateToString(scope.dates.dtAfter);
                }
                else if (scope.checks.beforeIsChecked) {
                    if (scope.dates.dtBefore == undefined) { scope.msgboxShow("Please select a valid date.", "Invalid date."); return; }
                    scope.dateSearch.dateOperation = scope.dateOperations.BeforeDate;
                    scope.dateSearch.beforeDateSearchValue = scope.dateToString(scope.dates.dtBefore);
                }
                else if (scope.checks.hasDateIsChecked) {
                    scope.dateSearch.dateOperation = scope.dateOperations.HasDate;
                }
                else if (scope.checks.hasNoDateIsChecked) {
                    scope.dateSearch.dateOperation = scope.dateOperations.HasNoDate;
                }

                //fire the datePicked event with the datesearch object
                scope.datePicked(scope.textboxId, scope.dateSearch);

                // Close the popup.
                scope.awcDatePickerShown = false;
            };

            //On Clear
            scope.onClear = function () {
                scope.dateSearch.onDateSearchValue = "";
                scope.dateSearch.beforeDateSearchValue = "";
                scope.dateSearch.dateOperation = "";
                scope.dateSearch.afterDateSearchValue = "";               
                scope.datePicked(scope.textboxId, "");
                scope.awcDatePickerShown = false;
            }

            // On Cancel.
            scope.onAWCDatePickerCancel = function () {
                scope.awcDatePickerShown = false;
            };

            // On Close.
            scope.awcDatePickerClosed = function () {
            };

        }

    }

})();